var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { staticClass: "header" }),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _vm.showMap
        ? _c(
            "div",
            { staticClass: "mapContainer" },
            [
              _c("map-component", {
                attrs: { autocompleteConfig: _vm.autocompleteConfig },
                on: { "error-on-map": _vm.errorOnMap }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bd2bee3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bd2bee3","hasScoped":false,"transformToRequire":{"video":["demo","poster"],"source":"demo","img":"demo","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/App.vue
// module id = null
// module chunks = 